import { render, staticRenderFns } from "./designers.vue?vue&type=template&id=58ca9ea2&"
import script from "./designers.vue?vue&type=script&lang=js&"
export * from "./designers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports